import PropTypes from "prop-types";
import React from "react";
import { useSelector } from "react-redux";
import { IntlProvider } from "react-intl";

function Locales({ children }) {
  const { locale, messages } = useSelector((state) => state.lang);

  return (
    <IntlProvider locale={locale} messages={messages}>
      {children}
    </IntlProvider>
  );
}

Locales.propTypes = {
  children: PropTypes.node,
};

export default Locales;
